import AssessmentIcon from "@mui/icons-material/Assessment";
import SearchIcon from "@mui/icons-material/Search";
import type { SvgIconComponent } from "@mui/icons-material";

export type ConversationMode = "pre_call" | "post_call";

interface ModeMeta {
  /** Canonical name used in both the selector and the conversation header. */
  label: string;
  /** One-line description shown in the selector card. */
  description: string;
  /** Theme palette color: info (blue) for pre-call, warning (orange) for post-call. */
  color: "info" | "warning";
  Icon: SvgIconComponent;
}

/**
 * Single source of truth for how each conversation mode is presented across the
 * app (mode selector cards + conversation header chip). Keeping this central
 * ensures the selector and header never drift in label, color, or icon.
 */
export const MODE_META: Record<ConversationMode, ModeMeta> = {
  pre_call: {
    label: "Pre-Call Research",
    description: "Prep before your call — briefing and prospect intel.",
    color: "info",
    Icon: SearchIcon,
  },
  post_call: {
    label: "Call Analysis",
    description: "Score and coach a completed call from its transcript.",
    color: "warning",
    Icon: AssessmentIcon,
  },
};
